/** Colunas do order by da pesquisa das campanhas */
export enum CampanhaSearchOrderBy {
    Numero = 1,
    Nome = 2,
    Status = 3,
    VigenciaRecorrente = 4,
    DataInicioAndamento = 5,
    DataTerminoVigencia = 6,
    NomeArea = 7,
    NomePacoteCampanha = 8,
    ObjetivoVenda = 9,
    ObjetivoBonificacao = 10,
    ObjetivoAquisicao = 11,
    ValorTotalRecursos = 12,
    ValorTotalPedidosVendas = 13,
    ValorTotalPedidosBonificacoes = 14,
    QuantidadeClientesAquisicoes = 15
};
